import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Hook: returns { hidden, isHidden } for the branch column visibility map.
//   * `hidden` — plain object keyed by column id (e.g. "orders.status") → bool.
//   * `isHidden(id)` — safe accessor; missing entry defaults to `false`.
//
// Fetched once on mount + on every window focus so a super-admin toggling
// a column in another tab is picked up without a manual refresh. Failure
// silently falls back to "all visible" — worst case is the branch user
// sees a column they shouldn't, never the reverse.
export default function useBranchColumnHidden() {
  const [hidden, setHidden] = useState({});

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/branch/column-settings`, { timeout: 8000 });
        if (!cancelled) setHidden(data?.hidden || {});
      } catch (err) {
        // Silent — default to "all visible".
      }
    };
    load();
    const onFocus = () => load();
    window.addEventListener('focus', onFocus);
    return () => {
      cancelled = true;
      window.removeEventListener('focus', onFocus);
    };
  }, []);

  return {
    hidden,
    isHidden: (id) => !!hidden[id],
  };
}
